import React from 'react';
import {Doughnut} from "react-chartjs-2";

import {
    chart1_2_options,
    chartExample3,
    doughnut_options
} from "variables/charts.js";

class PaymentChart extends React.Component {
    constructor(props) {
        super(props);
        this.state =  {
            Labels: []
        }
        this.salesChart = {
            all: canvas => {
                let ctx = canvas.getContext("2d");

                let gradientStroke = ctx.createLinearGradient(0, 230, 0, 50);

                gradientStroke.addColorStop(1, "rgba(29,140,248,0.2)");
                gradientStroke.addColorStop(0.4, "rgba(29,140,248,0.0)");
                gradientStroke.addColorStop(0, "rgba(29,140,248,0)"); //blue colors

                return {
                    labels: this.state.Labels,
                    datasets: [
                        {
                            label: "All Appointments",
                            fill: true,
                            backgroundColor: this.getBackgroundColours(),
                            borderColor: this.getBorderColours(),
                            borderWidth: 2,
                            borderDash: [],
                            borderDashOffset: 0.0,
                            pointBackgroundColor: "#1f8ef1",
                            pointBorderColor: "rgba(255,255,255,0)",
                            pointHoverBackgroundColor: "#1f8ef1",
                            pointBorderWidth: 20,
                            pointHoverRadius: 4,
                            pointHoverBorderWidth: 15,
                            pointRadius: 4,
                            data: this.getData()
                        }
                    ]
                };
            },
            options: doughnut_options
        };
    }

    getBorderColours = () => {
        return [
            'rgba(169, 50, 38 , 1)',
            'rgba(136, 78, 160 , 1)',
            'rgba(46, 134, 193, 1)',
            'rgba(23, 165, 137, 1)',
            'rgba(212, 172, 13, 1)',
            'rgba(208, 211, 212, 1)'
        ];
    }

    getBackgroundColours = () => {
        return [
            'rgba(169, 50, 38, 0.5)',
            'rgba(136, 78, 160 , 0.5)',
            'rgba(46, 134, 193, 0.5)',
            'rgba(23, 165, 137, 0.5)',
            'rgba(212, 172, 13, 0.5)',
            'rgba(208, 211, 212, 0.5)'
        ]
    }

    getData = () => {
        this.generateLabels();
        var d = [];
        const {data, view} = this.props;
        const {Labels} = this.state;
        for (var i = 0; i < Object.keys(Labels).length; i++) {
            d[i] = 0;
        }

        data.forEach(di => {
            //get the index it needs to go into
            var index = Labels.indexOf(this.getLabelFromNumber(di.PaymentMethod));
            if (index != -1) {
                d[index] = this.props.view === 'value' ? d[index] + di.DealValue : d[index] + 1;
            }

        });
        return d;
    }

    getLabelFromNumber = (number) => {
        switch (number) {
            case 247:
                return 'Cash';
            case 248:
                return 'EFT'
            case 249:
                return 'Credit Card';
            case 250:
                return 'Cheque';
            case 251:
                return 'No Deposit';
            case 418:
                return 'Other';
            default:
                return 'Unknown';
        }
    }

    generateLabels = () => {

        var l = [];
        const {data} = this.props;
        const {Labels} = this.state;
        data.forEach(i => {
            if (l.indexOf(this.getLabelFromNumber(i.PaymentMethod)) === -1) {
                l.push(this.getLabelFromNumber(i.PaymentMethod))
            }
        });
        if (this.state.Labels.join(' ') != l.join(' ')) {
            this.setState({Labels: l});
        }
    }

    render() {
        return (
            <>

                <Doughnut
                    data={this.salesChart.all}
                    options={doughnut_options}
                />
            </>
        )
    }
}

export default PaymentChart;